<template>
  <div class="main"> 
      <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="equipMenu" current="装备梯度"  />
        <div  class="r action-btn-box" v-show="!viewResult">
           <el-button @click="goto"  type="primary" :disabled="searchResult.length==0"  class="actionBtn"  round >装备梯度分析 <svg-icon name="play" size="12" ></svg-icon> </el-button> 
        </div>
      <xy-toolbox-menu class="r" v-show="viewResult">
          <xy-toolbox-menu-item icon="car_search" @click="goback" >返回</xy-toolbox-menu-item>
         <xy-toolbox-menu-item icon="sort" @click="openDialog">排序</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出  </xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
    <EquipSearch :moduleName="currentModuleName" v-if="!viewResult">
    
    </EquipSearch>
    <div v-if="viewResult" style="margin-top:20px;">
      
      <el-row>
        <el-col :span="4">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        </el-col>
        <el-col :span="20" style="text-align:left;">
          <el-checkbox-group v-model="checked_attr" @change="handleCheckedChange">
            <el-checkbox v-for="cat in chk_categories" :label="cat" :key="cat">{{cat}}</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <div class="pk1box">
        <h3></h3>
        <div v-html="content"></div>
        <h3></h3>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" width="50%" :before-close="hideDialog" :center="false" :show-close="true" :append-to-body="true">
      <span class="dialog-title clearfix" slot="title">
          <span>排序</span>
      </span>
      <draggable v-model="lines" element="ul" class="car-list" :options="dragOptions">
        <li v-for="(item) of lines" :key="item.id" class="left">
          <span class="text">{{item.name}} | {{item.msrp}}</span>
        </li>
      </draggable>
      <span slot="footer">
          <el-button @click="hideDialog">返回</el-button>
          <el-button type="primary" @click="sortCars">排序</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
  import EquipSearch from "@/components/common/NewSearchBar.vue";
  import Permissions from  '../../store/permissions.js'
  import draggable from "vuedraggable";
  const OptionPattern = /\(选装:\s?(?:[^()])*(\([^()]*\)[^()]*)*\)/g;
  const HasDigit = /\d+/;
  import {
    mapMutations,
    mapGetters,
    mapActions
  } from "vuex";
  import {
    formatDate,
    strToFormatDate
  } from "@/plugins/DateTimeFormater.js";
  export default {
    name: "saleanalysis",
    components: {
      EquipSearch,
      draggable
    },
    data() {
      return {
        menu:[{"name":"abc","link":"test","icon":"report","handle":function(){alert('test')}},
        {"name":"abc3","link":"test","icon":"report"}
        ],
        showDialog: false,
        viewResult: false,
        currentModuleName: "EquipGradientAnalysis",
        content: "loading...",
        categories: [],
        checkAll: true,
        isIndeterminate: false,
        checked_attr: [],
        chk_categories: [],
        pklist: [],
        pkids: [],
        paramData: [],
        lines: [],
        excelData: [],
        viewValue: 1,
        viewOptions: [{
            value: 1,
            label: "显示全部"
          },
          {
            value: 2,
            label: "仅显示相同"
          },
          {
            value: 3,
            label: "仅显示优劣势"
          }
        ]
      };
    },
    methods: {
      ...mapActions("equipanalysis", ["queryEquipParams"]),
      async queryData() {
        var postData = {
          ids: this.pkids
        };
        this.queryEquipParams({
          params: postData
        });
      },
      handleCheckAllChange(val) {
        this.checked_attr = val ? this.chk_categories : [];
        this.isIndeterminate = false;
        this.parseEq();
      },
      changeViewOption(val) {
        //  this.bindTable();
      },
      handleCheckedChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.chk_categories.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.chk_categories.length;
        this.parseEq();
      },
      openDialog() {
        this.showDialog = true;
      },
      hideDialog() {
        this.showDialog = false;
      },
      sortCars() {
        this.hideDialog();
        this.parseEq();
      },
      goback() {
        this.viewResult = false;
      },
      buddle_sort(arr) {
        let len = arr.length - 1;
        for (let j = 0; j < len; j++) {
          for (let i = 0; i < len - j; i++) {
            if (arr[i].msrp > arr[i + 1].msrp) {
              [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]];
            }
          }
        }
      },
      formatPrice(v) {
        if (v >= 0) {
          return "+" + v;
        } else {
          return "-" + v;
        }
      },
      bindData() {
        this.init_data();
        this.parseEq();
      },
      init_data() {
        this.margeEquip();
        this.chk_categories = this.categories.map(x => x.name);
        this.checked_attr = this.chk_categories;
       // this.buddle_sort(this.lines);
      },
      margeEquip() {
        var margeKeys = ["钥匙", "科技"];
        var filterKeys = ["参数", "动力"];
        var margeName = margeKeys.join(" & ");
        this.paramData = [];
        this.categories = [];
        if(this.lines==null || this.lines.length==0){
        this.lines = this.equipParamsList.lines;
        }
        for (const item of this.equipParamsList.categories) {
          if (filterKeys.findIndex(x => x == item.name) > -1) {
            continue;
          }
          if (margeKeys.findIndex(x => x == item.name) > -1) {
            continue;
          }
          this.categories.push(item);
        }
        this.categories.push({
          id: -1,
          name: margeName
        });
        for (const item of this.equipParamsList.dataDict) {
          if (filterKeys.findIndex(x => x == item.tag) > -1) {
            continue;
          }
          if (margeKeys.findIndex(x => x == item.tag) > -1) {
            this.paramData.push({
              name: item.name,
              val: item.val,
              tag: margeName,
              lines: item.lines
            });
          } else {
            this.paramData.push(item);
          }
        }
        //alert(JSON.stringify(this.paramData));
      },
      parseEq() {
        var arrlen = this.lines.length + 1;
        var html =
          ' <div class="pk-content" style="grid-template-columns: ' +
          " auto".repeat(arrlen) +
          ';">';
        for (var i = 0; i < arrlen; i++) {
          if (i == 0) {
            html += ' <div class="item car-label gy">名称</div>';
          } else {
            var line = this.lines[i - 1];
            html += ' <div class="item car-name">' + line.name + "   </div>";
          }
        }
        for (var i = 0; i < arrlen; i++) {
          if (i == 0) {
            html += ' <div class="item car-label gy">MSRP </div>';
          } else {
            var line = this.lines[i - 1];
            html += ' <div class="item car-name"> ￥ ' + line.msrp + " </div>";
          }
        }
        for (var i = 0; i < arrlen; i++) {
          if (i == 0) {
            html += ' <div class="item car-label gy"> </div>';
          } else if (i == 1) {
            html += ' <div class="item car-name"> - </div>';
          } else {
            var line = this.lines[i - 1];
            var priv = this.lines[i - 2];
            var diff = (line.msrp - priv.msrp);
            if (diff >= 0) {
              html += ' <div class="item car-name ls-different"> ￥ ' + this.formatPrice(diff) + ' </div>';
            } else {
              html += ' <div class="item car-name"> ￥ ' + this.formatPrice(diff) + ' </div>';
            }
          }
        }
        for (const item of this.categories) {
          if (this.checked_attr.findIndex(x => x == item.name) == -1) {
            continue;
          }
          for (var i = 0; i < arrlen; i++) {
            if (i == 0) {
              html += ' <div class="item car-label gy">' + item.name + "</div>";
            } else {
              if (i == 1) {
                var pk1a = this.find_line(this.lines[0].id, item.name);
                html += ' <div class="item car-name">' + this.fillEquip(pk1a) + " </div>";
              } else {
                var pk1a = this.find_line(this.lines[i - 1].id, item.name);
                var pk2a = this.find_line(this.lines[i - 2].id, item.name);
                html +=
                  ' <div class="item car-name">' +
                  this.pk(pk1a, pk2a, 1) +
                  this.pk(pk2a, pk1a, 1, "ls-remove") +
                  this.pk(pk1a, pk2a, 5, "ls-different") +
                  "  </div>";
              }
            }
          }
        }
        html += "</div>";
        this.content = html;
      },
      fillEquip(eq) {
        var html = '<ul class="ls-first">';
        eq.forEach(x => {
          if (!HasDigit.test(x.val)) {
            html += "<li> " + x.val + " </li>";
          } else {
            html += "<li> " + x.name + ":" + x.val + "</li> ";
          }
        });
        html += "</ul> ";
        return html;
      },
      pk(equip1, equip2, type, cls = "ls-plus") {
        var list = [];
        var html = '<ul class="' + cls + '">';
        var fix = "＋";
        if (cls == "ls-remove") {
          fix = "-";
        }
        equip1.forEach(x => {
          if (type == 1) { //增加
            var fd = equip2.find(item => item.name == x.name);
            if (!fd) {
              if (!HasDigit.test(x.val)) {
                html += "<li>" + fix + x.val + " </li>";
              } else {
                html += "<li>" + fix + x.name + ":" + x.val + "</li> ";
              }
            }
            //  if(fd&& fd.val != x.val)  
            //  {
            //      if (!HasDigit.test(x.val)) { 
            //       html += "<li>"    + fd.val + "->"+ x.val +" </li>";
            //     } else {
            //       html += "<li>"    + x.name + ":" + fd.val +  "->"+ x.val+"</li> ";
            //     }
            //  }
          } else if (type == 2) {
            var fd = equip2.find(item => item.name == x.name);
            if (fd && fd.val == x.val) {
              if (x.name == x.val) {
                html += "<li>+ " + x.val + " </li>";
              } else {
                html += "<li>+  " + x.name + ":" + x.val + "</li> ";
              }
            }
          } else if (type == 5) {
            var fd = equip2.find(item => item.name == x.name);
            if (fd && fd.val != x.val) {
              if (!HasDigit.test(x.val)) {
                html += "<li> " + x.val + " (" + fd.val + ")</li> ";
              } else {
                html += "<li> " + x.name + ": " + x.val + " (" + fd.val + ")</li> ";
              }
            }
          }
        });
        html += "</ul> ";
        return html;
      },
      goto() {
        //  this.viewResult = !this.viewResult;
        var ids = this.selectionResult.map(x => x.id);
        if (ids.length > 10) {
          this.$message({
            type: "error",
            message: "最多不超过10款车",
            duration: 2000
          });
          return;
        }
        this.viewResult = true;
        this.pkids = ids;
        this.queryData();
      },
      find_line(id, tag) {
        var result = [];
        
        for (var i = 0; i < this.paramData.length; i++) {
          var r = this.paramData[i];
          if (tag != r.tag) {
            continue;
          }
          for (var j in r.lines) {
            if (j == id) {
              var val = r.lines[j].replace(OptionPattern, '');
              if (val != "-" && val != '') {
                var line = {
                  id: id,
                  tag: r.tag,
                  name: r.name,
                  val: val
                };
                result.push(line);
              }
            }
          }
        }
        return result;
      },
      exportExcel() {
          // if(!Permissions.Client_ViewLine_Gradient_Down())
          //   {
          //      this.$message({ message: "没有下载权限。", duration: 2000 });
          //      return ;
          //   }
        var excelData = [];
        var msrpRow = {
          '名称': 'MSRP'
        };
        var priceRow = {
          '名称': 'Price'
        };
        var k = 0;
        for (var xf in this.lines) {
          var item = this.lines[xf];
           //var item = this.lines.find(x => x.id == lineId);
          msrpRow[item.name] = item.msrp;
          if (k == 0) {
            priceRow[item.name] = '';
          } else {
            var diff = this.lines[k].msrp - this.lines[k - 1].msrp;;
            priceRow[item.name] = this.formatPrice(diff);
          }
          k++;
        }
        excelData.push(msrpRow);
        excelData.push(priceRow);
        this.init_data();
        this.make_excel_rows(excelData);
        JSONToExcel(excelData, "装备梯度分析", "equip");
      },
      make_excel_rows(excelData) {
        var arrlen = this.lines.length + 1;
        for (const item of this.categories) {
          var row = {};
          if (this.checked_attr.findIndex(x => x == item.name) == -1) {
            continue;
          }
          for (var i = 0; i < arrlen; i++) {
            if (i == 0) {
              row['名称'] = item.name;
            } else {
              if (i == 1) {
                let pk1a = this.find_line(this.lines[0].id, item.name);
                row[this.lines[0].name] = this.fillEquip(pk1a);
              } else {
                let pk1a = this.find_line(this.lines[i - 1].id, item.name);
                let pk2a = this.find_line(this.lines[i - 2].id, item.name);
                row[this.lines[i - 1].name] =
                  ' <div class="item car-name">' +
                  this.pk(pk1a, pk2a, 1) +
                  this.pk(pk2a, pk1a, 1, "ls-remove") +
                  this.pk(pk1a, pk2a, 5, "ls-different") +
                  "  </div>";
              }
            }
          }
          excelData.push(row);
        }
      },
    },
    computed: {
      ...mapGetters("commonsearch", [
        "searchCategories",
        "hasSelectionResult",
        "hasSearchResult",
        "showSelectionSubmodel",
        "selectionResult",
        "searchResult"
      ]),
      ...mapGetters("equipanalysis", {
        equipParamsList: "equipParamsList"
      }),
      dragOptions() {
        return {
          animation: 0,
          group: "description"
        };
      }
    },
    watch: {
      equipParamsList(newValue) {
        this.bindData();
      }
    }
  };
</script>
<style>

</style>